import CheckupApi from "../api/checkup";

const env = process.env;
const checkupApi = new CheckupApi(
  env.VUE_APP_API_CHECKUP_URL,
  env.VUE_APP_API_CHECKUP_TIMEOUT
);

const state = {
  loaded: false,
  prescriptions: [],
  answers: [],
};

const getters = {};

const mutations = {
  SET_CHECKUP_PRESCRIPTIONS: (state, payload) => {
    state.prescriptions = payload;
    state.loaded = true;
  },

  SET_CHECKUP_ANSWERS: (state, payload) => {
    state.answers = payload;
  },
};

const actions = {
  LOAD_CHECKUP_PRESCRIPTIONS: async (context) => {
    const token = context.rootState.token;
    const result = await checkupApi.getPrescriptions(token);

    context.commit('SET_CHECKUP_PRESCRIPTIONS', result.items);
  },

  LOAD_CHECKUP_ANSWERS: async (context) => {
    const token = context.rootState.token;
    const result = await checkupApi.getAnswers(token);

    context.commit('SET_CHECKUP_ANSWERS', result.items);
  },

  POST_CHECKUP_ANSWERS: async (context, payload) => {
    const token = context.rootState.token;

    await checkupApi.postAnswers(token, payload);
    await context.dispatch('LOAD_CHECKUP_ANSWERS');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
